<script type="text/javascript">
    import { defineAsyncComponent } from 'vue';

    import FormGroup from '@/components/Form/Group.vue';
    import FormLabel from '@/components/Form/Label.vue';
    import FormInput from '@/components/Form/Input.vue';
    import FormText from '@/components/Form/Text.vue';
    import FormNumber from '@/components/Form/Number.vue';
    import FormFloatingLabel from '@/components/Form/FloatingLabel.vue';
    import InputGroup from '@/components/Form/InputGroup.vue';
    import InputGroupText from '@/components/Form/InputGroupText.vue';
    import CalendarFormComponents from '@/components/Form/Calendar/index.vue';
    import SelectComponents from '@/components/Form/Select/index.vue';
    import MultiFileInputComponents from '@/components/Form/MultiFileInput/index.vue';
    import FormStarsRating from '@/components/Form/StarsRating.vue';
    
    export default {
        FormGroup,
        FormLabel,
        FormInput,
        FormText,
        FormNumber,
        FormDate: defineAsyncComponent(() => import('@/components/Form/Date.vue')),
        FormDateTime: defineAsyncComponent(() => import('@/components/Form/DateTime.vue')),
        FormFloatingLabel,
        InputGroup,
        InputGroupText,
        FormCheckbox: defineAsyncComponent(() => import(/* webpackChunkName: "form-comp-group" */'@/components/Form/Checkbox.vue')),
        FormRange: defineAsyncComponent(() => import(/* webpackChunkName: "form-comp-group" */'@/components/Form/Range.vue')),
        FormDuelRange: defineAsyncComponent(() => import(/* webpackChunkName: "form-comp-group" */'@/components/Form/DuelRange.vue')),
        FormDob: defineAsyncComponent(() => import(/* webpackChunkName: "form-comp-group" */'@/components/Form/DOB.vue')),
        FormAddress: defineAsyncComponent(() => import(/* webpackChunkName: "form-comp-group" */'@/components/Form/Address.vue')),
        FormFaux: defineAsyncComponent(() => import(/* webpackChunkName: "form-comp-group" */'@/components/Form/Faux.vue')),
        FormStarsRating,
        FormTags: defineAsyncComponent(() => import('@/components/Form/Tags.vue')),
        FormColor: defineAsyncComponent(() => import('@/components/Form/Color.vue')),
        FormToggle: defineAsyncComponent(() => import('@/components/Form/Toggle.vue')),
        ...MultiFileInputComponents,
        ...CalendarFormComponents,
        ...SelectComponents,
    }
</script>